import GuestProcessing from './GuestProcessing';

export default GuestProcessing;
